import React from 'react';
import { apTheme } from '../../utils/agentPlatformTheme';

type Props = {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
};

export const AgentPlatformPanel: React.FC<Props> = ({
  title,
  description,
  actions,
  children,
  className = '',
  noPadding = false,
}) => (
  <section className={`${apTheme.panel} ${className}`}>
    {(title || actions) && (
      <div className={`flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 ${noPadding ? 'px-6 py-4' : 'px-6 py-4'}`}>
        <div>
          {title && <h2 className="text-base font-semibold text-slate-900">{title}</h2>}
          {description && <p className="text-sm text-slate-500 mt-0.5">{description}</p>}
        </div>
        {actions}
      </div>
    )}
    <div className={noPadding ? '' : 'p-6'}>{children}</div>
  </section>
);
